<template>
  <div class="contents1">
    <!-- pc -->
    <img class="bg" src="static/img/service/bg_white.png" v-show="!isMobile" />
    <div class="contents" v-show="!isMobile">
      <div class="text">
        <div class="wrap">
          <div class="icon">
            <img src="static/img/icon_car.png" />
          </div>
          <div class="title">자동차 <span>출장 정비</span></div>
          <div class="body">
            <p>
              집 또는 사무실 등 원하는 장소와 날짜에 전문 정비사가<br />
              직접 찾아가 엔진오일을 교체해 드립니다.
            </p>
            <p>
              카수리는 독일 직수입 정품 엔진오일과 필터류,<br />
              전문 정비사의 정확한 정비, 시간에 구애받지 않는 편리함을 추구하는<br />
              프리미엄 출장 전문 브랜드입니다.
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/intro?tab=0')"><img src="static/img/service/btn.png"/></a>
          </div>
        </div>
      </div>
      <div class="img">
        <img src="static/img/service/site_service_img_01.png" />
      </div>
    </div>
    <!-- mobile -->
    <div class="contents" v-show="isMobile">
      <div class="img">
        <img src="static/img/mobile/service/site_service_img_01_m.png" />
      </div>
      <div class="text">
        <img src="static/img/mobile/service/background_white_01.png" />
        <div class="wrap">
          <div class="icon">
            <img src="static/img/mobile/service/icon_car.png" />
          </div>
          <div class="title">자동차 <span>출장 정비</span></div>
          <div class="body">
            <p>
              집 또는 사무실 등 원하는 장소와 날짜에<br />
              전문 정비사가 직접 찾아가 엔진오일을<br />
              교체해 드립니다.
            </p>
            <p>
              카수리는 독일 직수입 정품 엔진오일과<br />
              필터류, 전문 정비사의 정확한 정비,<br />
              시간에 구애받지 않는 편리함을 추구하는<br />
              프리미엄 출장 전문 브랜드입니다.
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/intro?tab=0')"><img src="static/img/mobile/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    },
    gotoPage(path) {
      window.open(path)
    },
  },
}
</script>

<style scoped>
.contents1 {
  width: 100%;
  position: relative;
}
.contents1 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .contents1 .contents .icon img {
    width: 32px;
    height: auto;
  }
  .contents1 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents1 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents1 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #444444;
  }
  .contents1 .contents .btn img {
    width: 160px;
    height: auto;
  }
}
@media (min-width: 1280px) {
  .contents1 .contents .icon img {
    width: 2.5vw;
    height: auto;
  }
  .contents1 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents1 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents1 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #444444;
  }
  .contents1 .contents .btn img {
    width: 12vw;
    height: auto;
  }
}
@media (min-width: 641px) {
  .contents1 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .contents1 .text {
    width: 50%;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contents1 .img {
    width: 50%;
    height: 100%;
    float: left;
  }
  .contents1 .img img {
    width: 100%;
    height: 100%;
  }
  .contents1 .contents .body p {
    margin: 5% 0;
  }
  .contents1 .contents .btn {
    margin-top: 15%;
  }
  .contents1 .contents .btn a {
    cursor: pointer;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents1 .img img {
    width: 100%;
    height: 100%;
  }
  .contents1 .text {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .contents1 .text img {
    width: 100%;
    height: 100%;
  }
  .contents1 .text .wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 0 0 0 5%;
  }
  .contents1 .contents .icon img {
    width: 8vw;
    height: auto;
  }
  .contents1 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents1 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents1 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 4.3vw;
    line-height: 6.5vw;
    color: #444444;
  }
  .contents1 .contents .btn img {
    width: 50vw;
    height: auto;
  }
  .contents1 .contents .icon {
    margin-top: 15%;
    margin-bottom: 5%;
  }
  .contents1 .contents .body p {
    margin: 5% 0;
  }
  .contents1 .contents .btn {
    margin-top: 15%;
  }
  .contents1 .contents .btn a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/service/Contents1.vue